import { useEffect } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { DataTable } from "./DataTable";
import { useNavModel } from "@/model/navModel";
import { useSummaryModel } from "./summaryModel";
import { useDetailModel } from "../detail/detailModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const DataBox = () => {

    const { addNav } = useNavModel();
    const {
        summaryData, dataSource,
        selectedRowKeys,
        selectedData, setSelectedData,
        invoiceSummaryExport, invoiceSummaryExportAttach } = useSummaryModel();
    const { setCustomerCode } = useDetailModel();

    const desc: IDescription[] = [
        {
            label: "单据金额",
            value: summaryData?.totalBillAmount?.toFixed(2) ?? 0.00,
            color: (summaryData?.totalBillAmount ?? 0.00) > 0 ? DescriptionColorEnum.red : DescriptionColorEnum.green
        }, {
            label: "已开票金额",
            value: summaryData?.totalInvoiceAmount?.toFixed(2) ?? 0.00,
            color: (summaryData?.totalInvoiceAmount ?? 0.00) > 0 ? DescriptionColorEnum.red : DescriptionColorEnum.green
        }, {
            label: "未开票金额",
            value: summaryData?.totalNotInvoiceAmount?.toFixed(2) ?? 0.00,
            color: (summaryData?.totalNotInvoiceAmount ?? 0.00) > 0 ? DescriptionColorEnum.red : DescriptionColorEnum.green
        },
    ]

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData)
    }, [selectedRowKeys]);

    const onDetail = () => {
        if (selectedRowKeys && selectedRowKeys.length === 1) {
            if (selectedData) {
                setCustomerCode(selectedData.code);
            }
            addNav("14-1-1");
        } else {
            message.error("请选择单条数据进行操作");
        }
    }

    const action = (
        <>
            <div>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_INVOICING}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={onDetail}
                    >开票</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_EXPORT}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={invoiceSummaryExport}
                    >导出</Button>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_EXPORTATTACH}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={invoiceSummaryExportAttach}
                    >导出附件</Button>
                </YhAuth>
            </div>
        </>
    );

    return (
        <YhBox title={action} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}
